<template>

  <div class="recycle_container">
    <div class="detail_top" ref="pagesRef">
      <el-carousel :height="pagesHeight + 'px'" :autoplay="true" :interval="5000">
        <el-carousel-item v-for="(item,index) in detailImgList" :key="index">
          <img class="imgCls" :src="item.url">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="detail_center_one">
      <div class="center_one_title">
        <div class="center_one_title_line"></div>
        <div class="center_one_title_content">刷卡机</div>
        <div class="center_one_title_line"></div>
      </div>

      <div class="center_one_body_current">
        <img style="width: 85%" class="oneBodyImgCls" src="../../assets/images/kg4002_center_001.png"/>
      </div>

    </div>

    <div class="detail_center_two">

      <div class="center_two_a">
        <div class="center_two_a_left"></div>
        <div class="center_two_a_right"></div>
      </div>

      <div class="center_two_b">
        <div class="center_two_b_left"></div>
        <div class="center_two_b_center">刷卡机</div>
        <div class="center_two_b_right"></div>
      </div>

      <div class="center_two_c">
        <div class="center_two_c_a">
          幼教刷卡机是智能高清网络设备，集安全、考勤、管 理、信息发布等诸多功能于一体，是幼儿园实行科学管
          理的好帮手，是幼儿园亲子活动、校园活动的最佳宣传工具。幼教刷卡机可以在屏幕上实时显示学生卡、家长卡的刷卡信息及相应的人员姓名、班级、照片等信息，同时提供语音播报、刷卡拍照、照片导出、无线连接等诸多功能。
        </div>
      </div>

      <div class="center_two_d">外观尺寸</div>
      <div class="center_two_e">整机尺寸：420mm(宽)*460mm(厚)*1350mm(高)(不含自由移动滑轮)</div>
      <div class="center_two_e">主体尺寸：420mm(宽)*40mm(厚)*1300mm(高)</div>

      <div class="center_other_adorn_right">
        <img class="adorn_img" src="../../assets/images/home_center_adorn.png">
      </div>

      <div class="center_two_d">应用场景</div>
      <div class="center_two_e">
        居民社区，公共场所，学校，办公场所
      </div>

      <div class="center_two_d">功能</div>
    </div>

    <div class="detail_center_three">
      <div class="center_three_body_left">
        <div class="three_body_left_left_double">刷卡<br/>功能</div>
        <div class="three_body_left_right">刷卡后，屏幕上显示实时视频及孩子及接送人的照片。</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left_double">测温<br/>功能</div>
        <div class="three_body_right_right" style="text-align: right">测温仪（USB连接线）将测量数据显示到刷卡界面并上传到后台。
        </div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left_double">拍照<br/>功能</div>
        <div class="three_body_left_right">本机装有高清摄像头，在接送孩子时进行实时监控，拍摄并及时上传接、送孩子时的画面。</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left_double">播放<br/>功能</div>
        <div class="three_body_right_right" >非刷卡时间系统可以个性化定制播放内容，比如幼儿园的介绍、活动的照片视频、通知公告、一周菜谱等等。</div>
      </div>

    </div>

    <div class="detail_center_four">
      <img style="width: 40%;margin: 32px 0" src="../../assets/images/kg4002_center_002.png"/>
    </div>

  </div>

</template>

<script>

export default {
  data() {
    return {
      pagesHeight: "",
      detailImgList: [
        {
          url: require("../../assets/images/fk4151_top_001.png")
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.pagesHeight = this.$refs.pagesRef.clientHeight;
    })

  },
}
</script>

<style lang="less" scoped>

@import "../../assets/css/detailCommonSecond";

@media screen and (max-width: 1280px) {

  .center_one_body_current {
    height: 542px;

    .oneBodyImgCls {
      width: 100%;
      height: 542px;
    }

  }

}

@media screen and (min-width: 1281px) and (max-width: 1440px) {

  .center_one_body_current {
    height: 627px;

    .oneBodyImgCls {
      width: 100%;
      height: 627px;
    }
  }

}

@media screen and (min-width: 1441px) and (max-width: 1920px) {

  .center_one_body_current {
    height: 819px;

    .oneBodyImgCls {
      width: 100%;
      height: 819px;
    }
  }
}

.center_one_body_current {
  display: flex;
  flex-direction: row-reverse;

  .oneBodyImgCls {
  }
}

</style>